import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { baseUrl } from "../constant";

const paymentBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers, { endpoint }) => {
    const isAdmin = String(endpoint).startsWith("admin");
    const token = isAdmin
      ? localStorage.getItem("token")
      : localStorage.getItem("client-token");
    if (token) headers.set("Authorization", `Bearer ${token}`);
    return headers;
  },
});

export const paymentApi = createApi({
  reducerPath: "paymentApi",
  baseQuery: paymentBaseQuery,
  tagTypes: ["PaymentAccounts", "PaymentRequests", "UserBankAccounts"],
  endpoints: (build) => ({
    getPaymentAccounts: build.query({
      query: () => "/payment/accounts",
      providesTags: ["PaymentAccounts"],
    }),
    getMyPaymentRequests: build.query({
      query: () => ({
        url: "/payment/my-requests",
        method: "POST",
        body: {},
      }),
      providesTags: ["PaymentRequests"],
    }),
    getMyBankAccounts: build.query({
      query: () => ({
        url: "/payment/my-bank-accounts",
        method: "POST",
        body: {},
      }),
      providesTags: ["UserBankAccounts"],
    }),
    saveBankAccount: build.mutation({
      query: (body) => ({
        url: "/payment/save-bank-account",
        method: "POST",
        body,
      }),
      invalidatesTags: ["UserBankAccounts"],
    }),
    deleteBankAccount: build.mutation({
      query: (body) => ({
        url: "/payment/delete-bank-account",
        method: "POST",
        body,
      }),
      invalidatesTags: ["UserBankAccounts"],
    }),
    changePasswordSelf: build.mutation({
      query: (body) => ({
        url: "/user/changepassword-self",
        method: "POST",
        body,
      }),
    }),
    submitDeposit: build.mutation({
      query: (formData) => ({
        url: "/payment/submit-deposit",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["PaymentRequests"],
    }),
    submitWithdrawal: build.mutation({
      query: (body) => ({
        url: "/payment/submit-withdrawal",
        method: "POST",
        body,
      }),
      invalidatesTags: ["PaymentRequests"],
    }),
    adminGetAccounts: build.query({
      query: () => ({
        url: "/payment/admin/accounts",
        method: "POST",
        body: {},
      }),
      providesTags: ["PaymentAccounts"],
    }),
    adminSaveAccount: build.mutation({
      query: (body) => ({
        url: "/payment/admin/save-account",
        method: "POST",
        body,
      }),
      invalidatesTags: ["PaymentAccounts"],
    }),
    adminDeleteAccount: build.mutation({
      query: (body) => ({
        url: "/payment/admin/delete-account",
        method: "POST",
        body,
      }),
      invalidatesTags: ["PaymentAccounts"],
    }),
    adminGetRequests: build.query({
      query: (status = "pending") => ({
        url: "/payment/admin/requests",
        method: "POST",
        body: { status },
      }),
      providesTags: ["PaymentRequests"],
    }),
    adminProcessRequest: build.mutation({
      query: (body) => ({
        url: "/payment/admin/process-request",
        method: "POST",
        body,
      }),
      invalidatesTags: ["PaymentRequests"],
    }),
  }),
});

export const {
  useGetPaymentAccountsQuery,
  useGetMyPaymentRequestsQuery,
  useGetMyBankAccountsQuery,
  useSaveBankAccountMutation,
  useDeleteBankAccountMutation,
  useChangePasswordSelfMutation,
  useSubmitDepositMutation,
  useSubmitWithdrawalMutation,
  useAdminGetAccountsQuery,
  useAdminSaveAccountMutation,
  useAdminDeleteAccountMutation,
  useAdminGetRequestsQuery,
  useAdminProcessRequestMutation,
} = paymentApi;
